import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer>
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
          gap: "35px",
          padding: "50px 5% 30px",
        }}
      >
        <div>
          <div
            style={{
              fontSize: "18px",
              fontWeight: "800",
              marginBottom: "10px",
              color: "white",
            }}
          >
            ⚡ TechSphere
          </div>
          <p
            style={{
              fontSize: "13px",
              lineHeight: "1.8",
              color: "rgba(255,255,255,0.5)",
            }}
          >
            Where talent meets technology. Building the next generation of
            developers.
          </p>
        </div>
        <div>
          <h4
            style={{
              color: "white",
              marginBottom: "14px",
              fontSize: "13px",
              fontWeight: "700",
              letterSpacing: "1px",
              textTransform: "uppercase",
            }}
          >
            Quick Links
          </h4>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {[
              ["Home", "/"],
              ["Courses", "/courses"],
              ["Services", "/services"],
              ["Apply", "/apply"],
            ].map(([label, path]) => (
              <Link
                key={path}
                to={path}
                style={{
                  color: "rgba(255,255,255,0.5)",
                  textDecoration: "none",
                  fontSize: "14px",
                }}
              >
                {label}
              </Link>
            ))}
          </div>
        </div>
        <div>
          <h4
            style={{
              color: "white",
              marginBottom: "14px",
              fontSize: "13px",
              fontWeight: "700",
              letterSpacing: "1px",
              textTransform: "uppercase",
            }}
          >
            Contact
          </h4>
          <div
            style={{
              fontSize: "13px",
              lineHeight: "2.2",
              color: "rgba(255,255,255,0.5)",
            }}
          >
            <div>📧 techsphere@email.com</div>
            <div>📍 Karachi, Pakistan</div>
            <div>📱 +92 300 0000000</div>
          </div>
        </div>
      </div>
      <div
        style={{
          borderTop: "1px solid rgba(255,255,255,0.08)",
          padding: "18px 5%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <p style={{ fontSize: "13px" }}>
          © 2026 TechSphere — where talent meets tech
        </p>
        <p style={{ fontSize: "13px" }}>Made with ❤️ in Pakistan</p>
      </div>
    </footer>
  );
}
export default Footer;
